/**
 * Auth Provider Factory
 *
 * Creates the appropriate auth provider based on configuration.
 * Currently defaults to Supabase, but can be extended for custom JWT providers.
 */

import type { AuthProvider, AuthProviderType } from './types';
import { SupabaseAuthProvider } from './providers/supabase';

let cachedProvider: AuthProvider | null = null;

export function createAuthProvider(type: AuthProviderType = 'supabase'): AuthProvider {
  switch (type) {
    case 'supabase':
      return new SupabaseAuthProvider();
    case 'custom':
      // Future: Implement custom JWT provider
      throw new Error('Custom auth provider not yet implemented');
    default:
      throw new Error(`Unknown auth provider type: ${type}`);
  }
}

export function getAuthProvider(): AuthProvider {
  if (!cachedProvider) {
    // Read provider type from environment or default to supabase
    const providerType = (import.meta.env.VITE_AUTH_PROVIDER as AuthProviderType) || 'supabase';
    cachedProvider = createAuthProvider(providerType);
  }
  return cachedProvider;
}

export function resetAuthProvider(): void {
  cachedProvider = null;
}
